import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const CandleMagnitudeLine = observer(({
  tradePlanId,
  currentBracket,
  isOptionPosition,
  targets,
  size,
  scaleY,
  portalRef,
  fillPrice,
  openQuantity,
  priceMultiplier,
  realizedPnl,
  isLong,
  tickSize,
  delta,
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['CANDLE_MAGNITUDE']?.paused ?? null;
  const posMetrics = { fillPrice, openQuantity, priceMultiplier, realizedPnl, isLong, tickSize, delta };
  return (
    <>
      {scaleY ? (
        <g strokeWidth={1}>
          <g stroke={colors.green}>
            {targets.map((target, index) => {
              const yPos = scaleY(target.target);
              if (target.pctOfPosition === 0 || isOptionPosition) {
                return (
                  <g key={target.key}>
                    {paused ? (
                      <line
                        strokeDasharray={4}
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    ) : (
                      <line
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    )}

                    <HoverBox
                      json={{
                        Category: 'Exit Tactic',
                        Type: 'Candle Mag.',
                        'Pct. of Position': Number(target.pctOfPosition) * 100 + '%',
                      }}
                      topBoundary={yPos - 2}
                      bottomBoundary={yPos + 2}
                      leftBoundary={0}
                      rightBoundary={size}
                      portalRef={portalRef}
                      size={size}
                      linePrice={target.target}
                      {...posMetrics}
                    />
                  </g>
                );
              } else return null;
            })}
          </g>
          {currentBracket.stop > 0 && (
            <>
              {paused ? (
                <line
                  strokeDasharray={4}
                  stroke={colors.red}
                  x1={0}
                  x2={size}
                  y1={scaleY(currentBracket.stop)}
                  y2={scaleY(currentBracket.stop)}
                />
              ) : (
                <line
                  stroke={colors.red}
                  x1={0}
                  x2={size}
                  y1={scaleY(currentBracket.stop)}
                  y2={scaleY(currentBracket.stop)}
                />
              )}

              <HoverBox
                json={{
                  Category: 'Exit Tactic',
                  Type: 'Candle Mag.',
                  Stop: currentBracket.stop,
                }}
                topBoundary={scaleY(currentBracket.stop) - 2}
                bottomBoundary={scaleY(currentBracket.stop) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
                linePrice={currentBracket.stop}
                {...posMetrics}
              />
            </>
          )}
        </g>
      ) : null}
    </>
  );
});

CandleMagnitudeLine.propTypes = {
  currentBracket: PropTypes.shape({
    target: PropTypes.number,
    stop: PropTypes.number,
  }),
  isOptionPosition: PropTypes.bool,
  targets: PropTypes.array,
  stops: PropTypes.array,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any,
  fillPrice: PropTypes.number,
  openQuantity: PropTypes.number,
  priceMultiplier: PropTypes.number,
  realizedPnl: PropTypes.number,
  isLong: PropTypes.bool,
  tickSize: PropTypes.number,
  delta: PropTypes.number,
};
